

























import { Component, Vue } from 'vue-property-decorator'
import { mapGetters } from 'vuex'
import Question from '../models/Question'
import { State, Getter, Action, Mutation } from '../store-helper'
import { EDITOR_MODE } from '../stores/types'
import { qEditorState } from '../stores'

@Component({})
export default class NavigatorComponent extends Vue {
  get questions(){
    return qEditorState.questions
  }
  get editorMode(){
    return qEditorState.editorMode
  }

  get currentPage(){
    return qEditorState.displayCurrentPage
  }

  get isRevisionMode(){
    return qEditorState.isRevisionMode
  }

  constructor() {
    super()
  }

  public previous() {
    qEditorState.changePage({ page: this.currentPage - 1 })
  }

  public next() {
    qEditorState.changePage({ page: this.currentPage + 1 })
  }

  public changeMode() {
    if (this.editorMode == EDITOR_MODE.EDITOR) {
      qEditorState.setEditorMode({ editorMode: EDITOR_MODE.REVISION })
    } else {
      qEditorState.setEditorMode({ editorMode: EDITOR_MODE.EDITOR })
    }
  }

  get page(): number {
    return this.currentPage
  }

  set page(value: number) {
    qEditorState.changePage({ page: value })
  }
}
